/*
 * Copyright (c) 2022 Honeywell International, Inc. All rights reserved.
 *
 * This file contains trade secrets of Honeywell International, Inc.  No part
 *  may be reproduced or transmitted in any form by any means or for any
 *  purpose without the express written permission of Honeywell.
 *
 */
class FCDIYApplianceDetails {
  serialNumber: string = "";
  originalEndpoint: string = "";
  enrollmentId: string = "";
  constructor(
    serialNumber: string,
    originalEndpoint: string,
    enrollmentId: string
  ) {
    this.serialNumber = serialNumber;
    this.originalEndpoint = originalEndpoint;
    this.enrollmentId = enrollmentId;
  }
}

export default FCDIYApplianceDetails;
